import TStep from './step.vue'
import TStepItem from './step-item.vue'
TStep.Item = TStepItem

TStep.install = Vue => {
  Vue.component(TStep.name, TStep)
}

TStepItem.install = Vue => {
  Vue.component(TStepItem.name, TStepItem)
}
export {
  TStep,
  TStepItem
}



// WEBPACK FOOTER //
// ./src/module/steps/index.js